// 根据时间获取当前时间label
export function getTimeShowLable(timestamp_) {
    if (!timestamp_) {
        return "-";
    }
    var time = new Date(timestamp_ * 1000);
    var Y = time.getFullYear();
    var M = (time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1);
    var D = (time.getDate() < 10 ? '0' + (time.getDate()) : time.getDate());
    var h = (time.getHours() < 10 ? '0' + (time.getHours()) : time.getHours());
    var m = (time.getMinutes() < 10 ? '0' + (time.getMinutes()) : time.getMinutes());
    const today = new Date();
    // 获取当前时间(today)的年份
    const year = today.getFullYear();
    // 获取月份
    const month = String(today.getMonth() + 1).padStart(2, '0');
    // 获取当前日
    const day_ = String(today.getDate()).padStart(2, '0');
    if (year == Y && month == M && day_ == D) {
        return `${h}:${m}`;
    } else if (year == Y && month == M && (day_ - 1) == D) {
        return `昨天${h}:${m}`
    } else if (year == Y) {
        return `${M}-${D} ${h}:${m}`;
    } else {
        return `${Y}-${M}-${D} ${h}:${m}`;
    }
}
